import { c as _c } from "react/compiler-runtime";
import { FaroTextButton } from "@components/common/faro-text-button";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { tableTypeSelector } from "@store/table/table-selector";
import { setBulkActionName } from "@store/table/table-slice";
import { getMailHref } from "@utils/email-utils";
import { BulkActionEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { Text, EmailIcon } from "@flat-ui";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
/** Button to send emails to users in bulk */
export function BulkSendEmail(t0) {
  const $ = _c(16);
  const {
    selectedEntities
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const dispatch = useAppDispatch();
  const tableType = useAppSelector(tableTypeSelector);
  const mode = useBulkActionsMode();
  let t1;
  if ($[0] !== dispatch || $[1] !== selectedEntities || $[2] !== tableType || $[3] !== trackEvent) {
    t1 = function sendEmail() {
      dispatch(setBulkActionName("sendEmail"));
      if (tableType) {
        trackEvent({
          name: BulkActionEvents.bulkSendEmail,
          props: {
            dataType: tableType,
            numberOfEntities: selectedEntities.length
          }
        });
      }
      window.location.href = getMailHref({
        members: selectedEntities
      });
      dispatch(setBulkActionName(null));
    };
    $[0] = dispatch;
    $[1] = selectedEntities;
    $[2] = tableType;
    $[3] = trackEvent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const sendEmail = t1;
  let t2;
  if ($[5] !== mode) {
    t2 = getBulkActionButtonConfig(mode, "Send email to selected members");
    $[5] = mode;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const config = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <EmailIcon sx={{
      width: "18px",
      height: "18px"
    }} />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== config.shouldShowText) {
    t4 = config.shouldShowText && <Text variant="buttonM">Send email</Text>;
    $[8] = config.shouldShowText;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== config.rippleColor || $[11] !== config.sx || $[12] !== config.tooltipText || $[13] !== sendEmail || $[14] !== t4) {
    t5 = <FaroTextButton onClick={sendEmail} tooltipText={config.tooltipText} rippleColor={config.rippleColor} startIcon={t3} sx={config.sx}>{t4}</FaroTextButton>;
    $[10] = config.rippleColor;
    $[11] = config.sx;
    $[12] = config.tooltipText;
    $[13] = sendEmail;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}